import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { resultFrom } from './result';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  http = inject(HttpClient);

  static Forms = {
    Attachment: 'Attachment',
    Note: 'Note',
    SatReferral: 'SatReferral'
  };

  async post<T>(form: string, model: any) {
    return await resultFrom(this.http.post<T>(`${environment.serviceUrl}/forms/${form}`, model, { withCredentials: true }));
  }

  async get<T>(form: string, id: number) {
    const result = await resultFrom(this.http.get<T>(`${environment.serviceUrl}/forms/${form}/${id}`, { withCredentials: true }));
    return result.value;
  }

  async list(form: string) {
    return await resultFrom(this.http.get<any[]>(`${environment.serviceUrl}/forms/${form}`, { withCredentials: true }));
  }

  async postAttachment(form: string, formId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return await resultFrom(
      this.http.post(`${environment.serviceUrl}/forms/${form}/${formId}/attachment`, formData, { withCredentials: true })
    );
  }

  async openAttachment(id: number) {
    return await resultFrom(this.http.get(`${environment.serviceUrl}/forms/attachment/open/${id}`, { withCredentials: true }));
  }
}
